<template>
  <div class="common-Echarts-CircleStyle">
    <!-- 上半圆 -->
    <div class="CircleStyle-top">
    </div>
    <!-- 下半圆 -->
    <div class="CircleStyle-bottom">
    </div>
    <!-- 整体阴影 -->
    <div class="CircleStyle-shadow">
    </div>
    <!-- 数值-->
    <div class="CircleStyle-value">
      {{valueObj.MoneyValue}}
      <div>
        {{valueObj.MoneyUnit}}
      </div>
    </div>

  </div>
</template>

<script>
export default {
  components: {},
  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      valueObj: {}
    }
  },
  created() { },
  mounted() { },
  activated() { },
  updated() { },
  methods: {},
  computed: {},
  watch: {
    value: {
      handler(newvalue , oldvalue) {
        if(newvalue){
          this.valueObj = {
            MoneyValue: newvalue.StandardSumString || newvalue.YearAmountString,
            MoneyUnit: newvalue.MoneyUnit
          }
        }
      },
      deep: true,
      immediate: true
    }
  },
}
</script>
<style scoped lang='less'>
.common-Echarts-CircleStyle {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-content: center;
  margin-top: 20px;
  position: relative;

  .CircleStyle-top {
    width: 200px;
    height: 100px;
    border: 16px solid #e71d43;
    border-bottom: transparent;
    border-radius: 200px 200px 0 0; /* 左上、右上、右下、左下 */
    position: relative;
    z-index: 3;
  }
  .CircleStyle-top::after {
    content: "";
    width: 16px;
    height: 16px;
    position: absolute;
    top: 93px;
    left: -16px;
    background-color: #e71d43;
    border-radius: 50%;
    z-index: 3;
  }
  .CircleStyle-top::before {
    content: "";
    width: 16px;
    height: 16px;
    position: absolute;
    top: 93px;
    left: 200px;
    background-color: #e71d43;
    border-radius: 50%;
    z-index: 3;
  }

  .CircleStyle-bottom {
    width: 200px;
    height: 100px;
    border: 16px solid #002b66;
    border-top: transparent;
    border-radius: 0 0 200px 200px; /* 左上、右上、右下、左下 */
    position: absolute;
    top: 120px;
    z-index: 2;
  }
  .CircleStyle-shadow {
    width: 230px;
    height: 230px;
    border: 10px solid #fff;
    box-shadow: 0px 4px 10px 0px rgba(182, 199, 255, 0.3);
    position: absolute;
    top: -7px;
    z-index: 1;
    border-radius: 50%;
  }
  .CircleStyle-value {
    position: absolute;
    top: 80px;
    width: 100%;
    // height: 100%;
    color: #e71d43;
    background-color: transparent;
    z-index: 3;
    font-size: 25px;
    font-weight: 500;
    text-align: center;
  }
}
</style>